import { List, Create, Edit, ApiRoutes } from "../Components/index.js";

export default [
    {
        path: "/admin/settings/route",
        component: List,
        name: "settings.route-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/settings/route/:id/edit",
        component: Edit,
        name: "settings.route-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/settings/route/create",
        component: Create,
        name: "settings.route-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/api/route",
        component: ApiRoutes,
        name: "settings.api.route-list",
        meta: {
            requiresAuth: true,
        },
    },
];
